import TwoFA from './2FA';
export default TwoFA;
